import React from 'react';
import { Select } from "antd";
import RBHBox from "../rbh-box";
import styles from "./styles";
import RBHText from "../rbh-text";
import { FormattedMessage } from "react-intl";
import RBHSelect from "../rbh-select";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

interface PaginationProps {
    totalItems: number;
    pageSize: number;
    currentPage: number;
    pageSizeOptions: number[];
    onPageChange: (page: number) => void;
    onPageSizeChange: (size: number) => void;
}
export const Pagination: React.FC<PaginationProps> = ({
    totalItems,
    pageSize,
    currentPage,
    pageSizeOptions,
    onPageChange,
    onPageSizeChange,
}) => {
    const { Option } = Select;
    const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
    const startIndex = totalItems === 0 ? 0 : (currentPage - 1) * pageSize + 1;
    const lastIndex = Math.min(totalItems, currentPage * pageSize);
    const disablePrev = currentPage <= 1;
    const disableNext = currentPage >= totalPages;

    return (
        <RBHBox style={styles.paginationContainer} className="rbh-table-pagination">
            <RBHBox style={styles.paginationResults} className="rbh-table-pagination__results">
                <FormattedMessage id={'main.pagination.results'} />
                <RBHText
                    id={'report-pagination-text'}
                    data-testid={'report-pagination-text'}
                    text={'main.pagination.totalItems'}
                    values={{
                        startIndex: startIndex,
                        lastIndex: lastIndex,
                        totalItems,
                    }}
                />
                <FormattedMessage id={'main.pagination.perPage'} />
                <RBHSelect
                    value={pageSize}
                    style={styles.paginationSelect}
                    dropdownMatchSelectWidth={false}
                    dropdownClassName="rbh-table-pagination__page-size-dropdown"
                    onChange={(value: number) => onPageSizeChange(value)}
                >
                    {pageSizeOptions.map((size) => (
                        <Option key={size} value={size}>
                            {size}
                        </Option>
                    ))}
                </RBHSelect>
            </RBHBox>
            <RBHBox style={styles.paginationArrows}>
                <span
                    style={{
                        ...styles.paginationArrow,
                        ...(disablePrev ? styles.paginationArrowDisabled : {}),
                    }}
                    onClick={() => {
                        if (disablePrev) return;
                        onPageChange(currentPage - 1);
                    }}
                >
                    <LeftOutlined translate={null} />
                </span>
                <span
                    style={{
                        ...styles.paginationArrow,
                        ...(disableNext ? styles.paginationArrowDisabled : {}),
                    }}
                    onClick={() => {
                        if (disableNext) return;
                        onPageChange(currentPage + 1);
                    }}
                >
                    <RightOutlined translate={null} />
                </span>
            </RBHBox>
        </RBHBox>
    )
}